<template>
  <main-layout
    class="pb-4"
    small
  >
    <base-breadcrumb :routes="routes" />
    <appointments-list-container />
  </main-layout>
</template>

<script>
import AppointmentsListContainer from '@/components/Widgets/Appointments/AppointmentsListContainer';

export default {

  name: 'Index',
  components: { AppointmentsListContainer },
  data() {
    return {
    };
  },
  computed: {
    routes() {
      return [{
        name: 'Appointments',
      }, {
        name: 'All',
      }];
    },

  },
};
</script>
